"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SfEntityAutomationType = void 0;
var SfEntityAutomationType;
(function (SfEntityAutomationType) {
    SfEntityAutomationType[SfEntityAutomationType["Workflows"] = 1] = "Workflows";
    SfEntityAutomationType[SfEntityAutomationType["ValidationRules"] = 2] = "ValidationRules";
    SfEntityAutomationType[SfEntityAutomationType["Flows"] = 4] = "Flows";
    SfEntityAutomationType[SfEntityAutomationType["ProcessBuilders"] = 8] = "ProcessBuilders";
    SfEntityAutomationType[SfEntityAutomationType["ApexClasses"] = 16] = "ApexClasses";
    SfEntityAutomationType[SfEntityAutomationType["FormulaFields"] = 32] = "FormulaFields";
    SfEntityAutomationType[SfEntityAutomationType["ApexTriggers"] = 64] = "ApexTriggers";
    SfEntityAutomationType[SfEntityAutomationType["PageLayouts"] = 128] = "PageLayouts";
    SfEntityAutomationType[SfEntityAutomationType["EmailTemplate"] = 256] = "EmailTemplate";
    SfEntityAutomationType[SfEntityAutomationType["EmailAlerts"] = 512] = "EmailAlerts";
    SfEntityAutomationType[SfEntityAutomationType["FieldUpdates"] = 1024] = "FieldUpdates";
    SfEntityAutomationType[SfEntityAutomationType["AllProcessAutomations"] = 2047] = "AllProcessAutomations";
})(SfEntityAutomationType || (exports.SfEntityAutomationType = SfEntityAutomationType = {}));
//# sourceMappingURL=SfEntityAutomationType.js.map